import { useAuth } from "../context/AuthContext";
import { Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import ConstructionIcon from "@mui/icons-material/Construction";

const SeguridadSalud = () => {
  const { auth } = useAuth();
  const { t } = useTranslation();

  // if (auth.role !== "superAdmin") {
  //   return <Navigate to="/panel/dashboard" />;
  // }

  return (
    <Box
      sx={{
        padding: 4,
        textAlign: "center",
        color: "#333",
      }}
    >
      <ConstructionIcon sx={{ fontSize: 80, color: "#ff9800", mb: 2 }} />
      <Typography variant="h4" gutterBottom>
        {t("securityHealth.title")}
      </Typography>
      <Typography variant="h6" color="text.secondary" sx={{ mb: 2 }}>
        🚧 {t("securityHealth.comingSoonMessage")} 🚧
      </Typography>
      <HourglassBottomIcon sx={{ fontSize: 40, color: "#1976d2" }} />
    </Box>
  );
};

export default SeguridadSalud;
